@if (disciplines && disciplines.length) {
  <div class="library-project-disciplines flex gap-1">
    @for (discipline of disciplines; track discipline) {
      <span
        class="library-project-disciplines__icon"
        [ngStyle]="{ 'background-color': discipline.color }"
        matTooltip="{{ discipline.name }}"
        [matTooltipPosition]="'above'"
      >
        {{ discipline.id }}
      </span>
    }
  </div>
}
